export default "__VITE_ASSET__Dmf0q7op__"